// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"1235528b","308":"9ff0d35b","430":"95a761af","620":"bb9e6fb4","737":"5369b46b"}[chunkId] + ".chunk.js";
};